export default __webpack_public_path__ + "static/media/valleyPort1.fc8c8dff.png";